export default "__VITE_PUBLIC_ASSET__2c131ed1__"